import { forgetPasswordUrl, onBoardURL } from "../config";

// Login authentication logic 
export const loginAndStoreToken = async (email, password, backendUrl) => {
    try {
      const response = await fetch(backendUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
       
        body: JSON.stringify({ email, password }),
      });
      
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      // 🔐 Save entire login data
      localStorage.setItem("auth", JSON.stringify(data));
      const { token } = data;
      localStorage.setItem("token", token);
      // console.log(data)
  
   
      
  
      return true;
    } catch (error) {
      console.error('Login failed:', error);
      return false;
    }
  };
  
  // Login authentication logic  ended
  
  // logout logic 
  export const logout = () => {
    localStorage.setItem("token", "");
    localStorage.setItem("auth", "");

  }
  
  // logout logic  ended
   // start onboard 

   export const onboardUser = async (data) => {
    try {
      const response = await fetch(onBoardURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      const res = await response.json();
  
      if (!response.ok) {
        throw new Error(res.message || 'Network response was not ok');
      }
  
      return res;
    } catch (e) {
      console.error('Onboarding failed:', e);
      throw new Error(e.message || 'Failed to onboard user');
    }
  };
  
// forget password start
export const forgetPassword = async (email) => {
  try {
    const response = await fetch(forgetPasswordUrl,  {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });
    const res = await response.json();
    if (!response.ok) {
      throw new Error(res.message || 'Network response was not ok');
    }
    return res
  } catch(e) {
    console.error('Forget password failed:', e);
    throw new Error(e.message || 'Failed to send forget password email');
  }
}
// forget password end